export default {
  new_support_model: {
    wizard_steps: {
      step1: 'Descripción de tu inquietud',
      step2: 'Ayudas relacionadas',
      step3: 'Opciones de contacto',
    },
    described_inquery: {
      title: 'Hola, {{name}}, ¿cómo podemos ayudarte?',
      title_without_name: 'Hola, ¿cómo podemos ayudarte?',
      subtitle: 'Describe tu inquietud de forma general y te ayudaré a resolverla.',
      cta_btn: 'Continuar',
    },
    relationated_helps: {
      title: 'Ayudas relacionadas',
      subtitle:
        'Algunas personas con una inquietud similar encontraron solución en uno de los siguientes artículos:',
      tabs_label: {
        all: 'Todos',
        article: 'Artículos',
        video: 'Videos',
        community: 'Foro comunitario',
      },
      support_card: {
        title: '¿Sigues sin resolver tu inquietud?',
        description: 'Explora tus opciones de soporte y ponte en contacto con nuestro equipo.',
        cta_btn: 'Ver opciones de soporte',
      },
    },
    contact_options: {
      title: 'Opciones de contacto',
      subtitle: 'Estas son las opciones de soporte disponibles para tu plan',
      subtitle_acc: 'Estas son las opciones de soporte disponibles para ti',
      support_options: {
        chat: {
          title: 'Habla con un agente por chat',
          description_sales: 'Disponible de lunes a viernes de 9am a 1:30pm y de 3pm a 6:30pm',
          description: 'Disponible de lunes a viernes de 9am a 1:30pm y de 3pm a 6:30pm',
          description_acc: 'Disponible de lunes a viernes durante todo el día',
        },
        try_chat: {
          title: 'Habla con un agente por chat',
          description_sales:
            'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm Colombia <span style="color: #4F46E5;">¡Prueba gratis durante 15 días!</span>',
          description:
            'Disponible de lunes a viernes de 9am a 12:30pm y de 2pm a 6:30pm Colombia <span style="color: #4F46E5;">¡Prueba gratis durante 30 días!</span>',
        },
        group_training: {
          title: 'Agenda una capacitación grupal',
          description: 'Únete a una sesión grupal y amplía tus conocimientos en comunidad.',
        },
        individual_advice: {
          title: 'Agenda una asesoría individual',
          description:
            'Selecciona el horario que mejor se ajuste a tus necesidades y disponibilidad.',
        },
        send_email: {
          title: 'Envía un correo',
          description:
            'Nuestra bandeja de entrada está <strong>disponible las 24 horas</strong> para resolver tus dudas.',
          step1: {
            subtitle:
              'Déjanos tu duda o consulta por aquí, y pronto un agente te ayudará a resolver tu caso.',
            file: {
              label:
                '¿Tienes capturas, documentos o imágenes? Cárgalas aquí, esto nos ayudará a identificar tu problema.',
              hint: 'Solo archivos JPG or PNG menores a 500mb',
            },
          },
          message_final: {
            title: '¡Correo enviado!',
            message: 'Nos pondremos en contacto muy pronto.',
            advice: 'Si no encuentras el correo, busca en la carpeta de Promociones o Spam.',
          },
        },
        whatsapp: {
          title: 'Escríbenos por WhatsApp',
          description:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales_acc:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
        },
        call_agent: {
          title: 'Llama a un agente de soporte',
          description: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          message_final: {
            title: 'Llama al {{phone}} para hablar con un agente de soporte',
            message: 'Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          },
        },
        comunity_forum: {
          title: 'Consulta en el foro comunitario',
          description: 'Haz preguntas y obtén respuestas de la comunidad de usuarios de Alegra.',
        },
      },
      banner_upsell: {
        title: 'Accede a más opciones de soporte',
        description:
          'Mejora tu plan y ten acceso a más canales de soporte para recibir ayuda especializada cuando la necesites',
        ctas_btn: {
          upgrade: 'Actualizar plan',
          contact: 'Hablar con ventas',
          contact_support: 'Hablar con soporte',
        },
        modals: {
          contact: {
            title: 'Llama a un agente de Alegra',
            message_final: {
              title: 'Llama al {{phone}} y contacta a {{agent}}',
              message:
                'Disponible de lunes a viernes de 8:00 a.m. a 12:00 m. y de 2:00 p.m. a 5:30 p.m.',
            },
          },
        },
      },
    },
  },
}
